import { render, staticRenderFns } from "./notices.vue?vue&type=template&id=44b86b46&scoped=true"
import script from "./notices.vue?vue&type=script&lang=js"
export * from "./notices.vue?vue&type=script&lang=js"
import style0 from "./notices.vue?vue&type=style&index=0&id=44b86b46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b86b46",
  null
  
)

export default component.exports